import React from 'react';
import Section from '../common/Section';
import styles from '../../styles/modules/common/content.module.scss';
import { Hidden } from '@mui/material';
import Image from '../common/Image';
// {/* <Image src={banner_img || ''} alt={title} width="730" height="516" /> */}





const WhyToDo = () => {
    return (
        <Section hasPadding={false} className={`${styles.nopad}`}>     
            <div className="container">
                <div className="row">
                    <div className={`${styles.whytodo__image} col-12  col-lg-6`}>
                    <Hidden mdUp>
                        <div><h2 className={`${styles.headernoleft}`}> Why We Do What We Do?</h2></div>
                    </Hidden>
                        <Image src={"/static/images/aboutus/WOW.png"|| ''} alt={"placeholder"} width="500" height="333" />
                        
                    </div>
                    <div className={`${styles.textcontent} col-12  col-lg-6`} >
                    <Hidden mdDown>
                    <div><h2 className={`${styles.headernoleft}`}> Why We Do What We Do?<em className="title-el-cap"></em></h2></div>
                    </Hidden>
                    
                    <p className={`${styles.whytodo__para}`}>The entire device ownership experience of the customer is centered around the brand or the retailer. Brands make fantastic gadgets and retailers are great at selling those gadgets. However, if something goes wrong, getting help from either the brand or the retailer is hectic and troublesome. This is where Onsitego steps in to provide hassle-free and delightful customer service. </p>

                    <p className={`${styles.whytodo__para}`}>Our award-winning customer service combined with our thoughtful plans ensure the best care you invest in for your devices & appliances.</p>


                      </div>
                </div>
            </div>
        </Section>
    );
}

export default WhyToDo;